import {
  useTheme,
  Typography,
  Snackbar,
  Alert,
  Autocomplete,
  TextField,
  Stack,
} from "@mui/material";
import { Outlet, useLocation } from "react-router";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { useOutletContext } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorMessage from "../../componentes/easyMaps/errorMessage";

export default function EasyMaps(props) {
  const [snackbar, setSnackbar] = useState(null);
  const [mapGroups, setMapGroups] = useState([]);
  const [recentMaps, setRecentMaps] = useState([]);
  const [maps, setMaps] = useState([]);
  const [loadingPage, setLoadingPage] = useState([]);
  const [ftthLoadingPage, setFtthLoadingPage] = useState(false);
  const { config, setOpenConfig, titlePage } = useOutletContext();

  const theme = useTheme();
  const location = useLocation();

  async function handleApi() {
    try {
      setLoadingPage(true);
      setMaps([]);

      const groupMapsPromise = handleApiGetGroupMaps();
      const mapsPromise = handleApiGetMaps();
      const ftthPromise = handleApiGetFtth();
      const recentMapsPromise = handleApiGetRecentMaps();

      await groupMapsPromise;
      await mapsPromise;
      await recentMapsPromise;
    } catch (error) {
    } finally {
      setLoadingPage(false);
    }
  }
  useEffect(() => {
    if (!config) return;
    handleApi();
  }, [config]);

  async function handleApiGetMap(id) {
    setLoadingPage(true);
    try {
      const response = await api.post("/easyMaps/map/resume/findById", {
        mapId: id,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar o mapa",
          severity: "error",
        });
      } else {
        if (response.data) {
          if (response.data.id === undefined) {
            setSnackbar({
              children: "Error: Mapa não encontrado",
              severity: "error",
            });
            return;
          }
          setMaps((prevMaps) => {
            const existingIds = new Set(prevMaps.map((m) => m.id));
            const newMaps = response.data;
            if (existingIds.has(newMaps.id)) return prevMaps;
            return [...prevMaps, newMaps];
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      setLoadingPage(false);
    }
  }

  async function handleApiGetMaps() {
    try {
      const response = await api.get("/easyMaps/map/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMaps((prevMaps) => {
            const existingIds = new Set(prevMaps.map((m) => m.id));
            const newMaps = response.data.filter((m) => !existingIds.has(m.id));
            return [...prevMaps, ...newMaps];
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function handleApiGetFtth() {
    try {
      setFtthLoadingPage(true);
      const response = await api.get("/easyMaps/map/findFtth");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMaps((prevMaps) => {
            const existingIds = new Set(prevMaps.map((m) => m.id));
            const newMaps = response.data.filter((m) => !existingIds.has(m.id));
            return [...prevMaps, ...newMaps];
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      setFtthLoadingPage(false);
    }
  }

  async function handleApiGetGroupMaps() {
    try {
      const response = await api.get("/easyMaps/groupMaps/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os Grupos de Mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMapGroups(response.data);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function handleApiGetRecentMaps() {
    try {
      const response = await api.get("/easyMaps/recentMaps");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os Mapas Recentes",
          severity: "error",
        });
      } else {
        if (response.data) {
          setRecentMaps(response.data);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  function formatedTitle(input) {
    const parts = input.replace("geolocalizado", "geolocalização").split("/");

    const capitalize = (str) =>
      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    let title = "";
    parts.map((a, index) => {
      if (index != 0) title += " de " + capitalize(a);
      else title += capitalize(a);
    });
    // Retorna o texto formatado
    return title;
  }

  return (
    <>
      <ErrorBoundary
        FallbackComponent={() => (
          <ErrorMessage message={"Algo deu errado ao carregar o EasyMaps."} />
        )}
      >
        <Stack spacing={1} direction={"row"}>
          {Array.isArray(titlePage) &&
            titlePage.map((titleSegment, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: { xs: "18px", sm: "20px" },
                  color:
                    index === titlePage.length - 1 && titlePage.length > 1
                      ? theme.palette.primary.main
                      : theme.palette.text.primary,
                }}
              >
                {titleSegment + (index < titlePage.length - 1 ? " ›" : "")}
              </Typography>
            ))}
        </Stack>
        <Outlet
          context={{
            maps,
            mapGroups,
            recentMaps,
            loadingPage,
            setMaps,
            setMapGroups,
            api,
            setOpenConfig,
            ftthLoadingPage,
            handleApiGetMap,
            handleApiGetMaps,
            setLoadingPage,
          }}
        />
      </ErrorBoundary>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
